import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  public closableByDefault = true;

  private openSubject = new Subject<boolean>();

  open$ = this.openSubject.asObservable();

  constructor() {}

  open() {
    this.openSubject.next(true);
  }

  close() {
    this.openSubject.next(false);
  }
}
